import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Collapse,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import MaterialTable from "material-table";
import "../../assets/scss/components/MeterialTable/index.scss";
import get from "lodash/get";

// import { fetchVinLookup } from "../../redux/VinLookup/action";
import InputText from "../InputText";
import VinLookupDetailPanel from "../VinLookupDetailPanel";
import Loader from "../Loader";
import { toast } from "react-toastify";
import { Icon } from "react-icons-kit";
import { filePdfO } from "react-icons-kit/fa/filePdfO";
import "react-toastify/dist/ReactToastify.css";

const _ = { get };

class VinLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      vin: "",
      email: "",
      phone: "",
      toggleModal: false,
      document: "",
      docInfo: "",
      uploadErr: false,
    };
  }

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let newState = this.state;
    newState.vin = e.target.value;
    this.setState(newState);
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  onDocumentUpload = (e) => {
    console.log("eventss", Array.from(e.target.files).length);
    if (Array.from(e.target.files).length > 3) {
      let newState = { ...this.state };
      newState.uploadErr = true;
      this.setState(newState);
    } else {
      this.props.clearReducer();
      let newState = { ...this.state };
      let documents = [];
      let documentInfo = [];
      for (let i = 0; i < e.target.files.length; i++) {
        documents.push(URL.createObjectURL(e.target.files[i]));
        documentInfo.push(e.target.files[i]);
        this.props.uploadUrl(e.target.files[i]);
      }
      newState.document = [...documents];
      newState.docInfo = [...documentInfo];
      newState.uploadErr = false;
      this.setState(newState);
    }
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();

    this.props.fetchVinLookup(this.state.vin);
  };

  handleClearFilter = () => {
    let state = this.state;
    state.vin = "";
    this.setState({ ...state });
    let data = {
      vin: "",
    };
    this.props.fetchVinLookup(data);
  };

  handleSearchByButton = (value) => {
    let state = this.state;
    state.searchBy = value;
    this.setState({ ...state });
  };

  handleUserSearch = () => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (this.state.email.email !== "") {
      if (emailPattern.test(this.state.email) === true) {
        let user = {
          page: 0,
          phone: "",
          email: this.state.email,
          limit: 100,
        };
        this.props.fetchAllUser(user);
      } else {
        toast.error(
          _.get(
            this.props.elements,
            "vinLookupElement.validEmailValidationElement",
            "Enter Valid Email"
          )
        );
      }
    }
  };

  handleSetValue = (e) => {
    let newState = this.state;
    newState.email = e.target.value;
    this.setState(newState);
  };

  handleTransferOwnership = () => {
    let data = {
      vehicleId: this.props.vinLookup[0]._id,
      ownerId: this.props.vinLookup[0].userID._id,
      buyerId: this.props.allUser && this.props.allUser[0]._id,
      rceUrlsArr: this.props.documentRead,
    };

    this.props.changeOwnershipTransfer(data);
    this.handleToggleModel();
  };

  handleClearState = () => {
    let newState = { ...this.state };
    newState.email = "";
    this.setState(newState);
  };

  render() {
    let { elements } = this.props;
    console.log(this.props.allUser);

    return (
      <React.Fragment>
        {this.props.vinLookupStatus || this.props.ownershipTransferStatus ? (
          <Loader />
        ) : null}
        <div className="hideSearch">
          <Form onSubmit={this.handleSubmitFilter}>
            <Row>
              <Col sm={12}>
                <CartTitle
                  title={_.get(
                    elements,
                    "vinLookupElement.headingElement",
                    "VIN Lookup"
                  )}
                  Name={_.get(
                    elements,
                    "vinLookupElement.filterButtonElement",
                    "Filter"
                  )}
                  handleToggle={() => this.handleToggle()}
                  iconClass={"hideexcel"}
                  preRegisteredUserCount={this.props.dealerCount}
                />
              </Col>
              <Col sm={12}>
                <Collapse isOpen={this.state.toggleActive}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row>
                        <Col xl={4} lg={4} md={6} sm={6}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "vinLookupElement.labelElement",
                              "VIN"
                            )}
                            inputType={"text"}
                            labelClass={"vinLabelCase"}
                            customValue={this.state.vin}
                            inputName={"vin"}
                            InputClass={"my-2 inputText position-relative"}
                            inputPlaceholder={_.get(
                              elements,
                              "vinLookupElement.vinPlaceholder",
                              "Enter VIN"
                            )}
                            customOnChange={(e) => this.handleFilterChange(e)}
                            customRequired={true}
                            customMaxLength={17}
                          />
                        </Col>
                      </Row>

                      <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "vinLookupElement.searchButtonElement",
                            "Search"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "vinLookupElement.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={this.handleClearFilter}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Collapse>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col sm="12">
              <div className="custom-m-table">
                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: _.get(
                        elements,
                        "vinLookupElement.nameElement",
                        "Name"
                      ),
                      render: (rowData) =>
                        `${rowData.userID.fName} ${rowData.userID.lName}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinLookupElement.modelNameElement",
                        "ModelName"
                      ),
                      render: (rowData) => `${rowData.vehicleModelName}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "vinLookupElement.vinElement",
                        "VIN"
                      ),
                      render: (rowData) => `${rowData.vin}`,
                    },
                  ]}
                  data={this.props.vinLookup}
                  options={{
                    actionsColumnIndex: -1,
                    search: false,
                    paging: true,
                    sorting: false,
                    pageSize: 10,
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h6>
                          {_.get(
                            elements,
                            "vinLookupElement.noRecordsFoundElement",
                            "No records to display"
                          )}
                        </h6>
                      ),
                    },
                    pagination: {
                      labelRowsSelect: _.get(
                        elements,
                        "customMaterialTableElement.labelRowsSelect",
                        "rows"
                      ),
                      previousTooltip: _.get(
                        elements,
                        "customMaterialTableElement.previousTooltip",
                        "previous"
                      ),
                      nextTooltip: _.get(
                        elements,
                        "customMaterialTableElement.nextTooltip",
                        "next"
                      ),
                    },
                    header: {
                      actions: _.get(
                        elements,
                        "vinLookupElement.actionsElement",
                        "Actions"
                      ),
                    },
                  }}
                  detailPanel={(rowData) => (
                    <VinLookupDetailPanel
                      rowData={rowData}
                      email={this.state.email}
                      handleSetValue={this.handleSetValue}
                      handleUserSearch={this.handleUserSearch}
                      handleToggleModel={this.handleToggleModel}
                      allUser={this.props.allUser}
                      allUserStatus={this.props.allUserStatus}
                      clearReducer={this.props.clearReducer}
                      clearState={this.handleClearState}
                      elements={this.props.elements}
                    />
                  )}
                />
                <Modal
                  isOpen={this.state.toggleModal}
                  toggle={this.handleToggleModel}
                  backdrop={true}
                  centered={true}
                  size="lg"
                >
                  <ModalHeader toggle={this.handleToggleModel}>
                    {_.get(
                      elements,
                      "vinLookupElement.confirmationTextElement",
                      "Confirmation"
                    )}
                  </ModalHeader>
                  <ModalBody className="d-flex flex-column">
                    <h5 className="p-5">
                      {`${_.get(
                        elements,
                        "vinLookupElement.ownershipConfirmationTextElement",
                        "Are you sure you want to transfer the ownership of the vehicle"
                      )} 
                       (${
                         this.props.vinLookup.length
                           ? this.props.vinLookup[0].vin
                           : ""
                       }) ${_.get(
                        elements,
                        "vinLookupElement.fromTextElement",
                        "from"
                      )}  ${
                        this.props.vinLookup.length &&
                        this.props.vinLookup[0].userID
                          ? this.props.vinLookup[0].userID.fName
                          : ""
                      } ${
                        this.props.vinLookup.length &&
                        this.props.vinLookup[0].userID
                          ? this.props.vinLookup[0].userID.lName
                          : ""
                      } ${_.get(
                        elements,
                        "vinLookupElement.toTextElement",
                        "to"
                      )} ${
                        this.props.allUser.length
                          ? this.props.allUser[0].fName
                          : ""
                      } ${
                        this.props.allUser.length
                          ? this.props.allUser[0].lName
                          : ""
                      }`}
                    </h5>

                    <input
                      type="file"
                      accept=".pdf, .jpg, .jpeg, .png"
                      onChange={this.onDocumentUpload}
                      className="mb-3 ml-5"
                      multiple
                    />
                    {this.state.uploadErr ? (
                      <span className="danger">
                        {_.get(
                          elements,
                          "vinLookupElement.uploadErrorElement",
                          "Can not Upload more than 3 Files"
                        )}
                      </span>
                    ) : (
                      <div className="d-flex chooseImage">
                        {this.state.docInfo.length > 0 &&
                          this.state.docInfo.map((info) => {
                            return info.type == "application/pdf" ? (
                              <div className="pdf_Border align-items-center text-center text-break position-relative mr-2">
                                <div className="position-absolute pdf_Center_Text">
                                  <div>
                                    <Icon size={20} icon={filePdfO} />
                                  </div>
                                  <div
                                    className="pdf_Font"
                                    title="Click to PDF"
                                  >
                                    {info.name.slice(
                                      info.name.lastIndexOf("/") + 1
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <img
                                src={URL.createObjectURL(info)}
                                className="mr-2"
                              />
                            );
                          })}
                      </div>
                    )}
                    <div className="d-flex justify-content-end mt-3">
                      <CustomButton
                        name={_.get(
                          elements,
                          "vinLookupElement.confirmButtonElement",
                          "Confirm"
                        )}
                        customClass={
                          "btn-outline-dark bg-none btnthemeColor ml-auto"
                        }
                        customClick={() => this.handleTransferOwnership()}
                      />
                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default VinLookup;
